import React from "react";

import type { TVehicle } from "types";

import { Chip } from "../Chip";

import { getOffersFromVehicle } from "helper/finance_helper";

interface IFinanceTypesIndicator {
  vehicle: TVehicle;
  translate: any;
}
const FinanceTypesIndicator: React.FC<IFinanceTypesIndicator> = ({
  vehicle,
  translate,
}): JSX.Element | null => {
  const offers = getOffersFromVehicle(vehicle);
  const uniqueTypes = Array.from(new Set(offers.map((offer) => offer.type)));
  if (!uniqueTypes.length) return null;
  return (
    <>
      {uniqueTypes.map((type) => (
        <Chip
          sx={{ backgroundColor: "grey.400", color: "black" }}
          label={translate({
            id: "filter.financial.v2.rateType.options." + type + ".label",
          })}
        />
      ))}
    </>
  );
};

export default FinanceTypesIndicator;
